import { Button } from '@jouzen/ecom-components/v3/Button';
import { Modal } from '@jouzen/ecom-components/v3/Modal';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useFeatureGate } from '@statsig/react-bindings';
import { useTranslations } from 'next-intl';

import { useAddOnBundleContext } from '@/app/[locale]/meta/_contexts/AddOnBundleProvider';

import ExtendWarrantySection from './ExtendWarrantySection';
import ModalFixedFooter from './ModalFixedFooter';
import OneYearMembershipSection from './OneYearMembershipSection';

const AddOnModal = () => {
  const hsaFsaGate = useFeatureGate('hsafsa_rollout').value;
  const t = useTranslations();
  const { onOpenModal, isModalOpen } = useAddOnBundleContext();
  return (
    <>
      <Modal
        isOpen={isModalOpen}
        variant="lightest"
        className={'md:ui-w-1/2 md:ui-max-h-1/2 ui-min-h-full md:rounded-xl'}
        size={'full'}
        onOpenChange={(isOpen: boolean) =>
          onOpenModal({ modalOpenInput: isOpen })
        }
        fixedFooter={<ModalFixedFooter />}
      >
        <Typography
          className="pt-5 pb-3 text-3xl font-medium md:pb-8"
          data-cy="bundle_title"
        >
          {t('bundle_modal_title')}
        </Typography>
        {hsaFsaGate ? (
          <Typography
            className="border-b-2 border-sandstone-400 pb-5 text-base font-medium"
            data-cy="hsa_fsa_subtitle"
          >
            {t('bundle_modal_subtext_hsa_fsa')}
          </Typography>
        ) : (
          <Typography
            className="border-b-2 border-sandstone-400 pb-5 text-base font-medium"
            data-cy="default_subtitle"
          >
            {t('bundle_modal_subtext')}
          </Typography>
        )}

        <div className="pt-5 pb-1 md:flex md:justify-between md:pt-8 md:pb-4">
          <OneYearMembershipSection />
          <ExtendWarrantySection />
        </div>
      </Modal>
      {/* Open Modal Button Trigger */}
      <Button
        data-cy="button-open-bundle-modal"
        loadingTextEnabled
        size="large"
        type="submit"
        onClick={() => onOpenModal({ modalOpenInput: true })}
      >
        {t('meta_checkout_button_label')}
      </Button>
    </>
  );
};
export default AddOnModal;
